import type { IMTokens } from '@/interface/IMTokens';
import { LeagueSize, SportType } from '@/interface/enum';
import { useOddsApiStore } from '@/store/oddsApiStore';

const leagueSizeTokenKey: Record<LeagueSize, Exclude<keyof IMTokens, 'e'>> = {
    [LeagueSize.Big]: 'b',
    [LeagueSize.Medium]: 'm',
    [LeagueSize.Small]: 's',
};

export function useOddsToken() {
    function getOddsToken(sportType: SportType, leagueSize: LeagueSize, isSimulation: boolean): string {
        const oddsApiStore = useOddsApiStore();
        const tokens = sportType === SportType.Soccer ? oddsApiStore.soccerMOddsTokens : oddsApiStore.othersMOddsTokens;
        const leagueSizeToken = tokens[leagueSizeTokenKey[leagueSize]];
        return isSimulation ? tokens.e ?? leagueSizeToken : leagueSizeToken;
    }

    return {
        getOddsToken,
    };
}
